import React from 'react';
import MSectionCollection, { MSECTION_MODE_TAB, MSECTION_MODE_SECTION } from 'components/Shared/MSectionCollection';
import ReoMit from 'components/Homeowner/CaseForms/REOMIT/REOMIT';
import ReoRepair from "components/Homeowner/CaseForms/REOMIT/ReoRepair"
import HiringNeed from 'components/HiringNeed';

const AnandTestPage = () => {
  return (
    <div className="padding-page-content full-height">
      <MSectionCollection
        defaultMode={MSECTION_MODE_TAB}
        tabModeCollapsible={false}
        fullHeight
        sections={[
          { title: "CASE", children: <ReoMit controlNumber="14619360"/> },
          { title: "RepairUpdates", children: <ReoRepair controlNumber="14619360" /> },
        ]}
      />
    </div >
  );
}

export default AnandTestPage;